module.exports = __webpack_public_path__ + "static/media/hamburger-menu.e9beeb8a.svg";